import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { domAnimation, LazyMotion, MotionConfig } from 'motion/react';
import { ApiError } from './lib/api';
import { SessionProvider } from './lib/session';
import { installTheme } from './lib/theme';
import { ToastProvider } from './components/ui/Toast';
import { router } from './router';
import './styles/index.css';

// Tokens da identidade neutra antes do primeiro render; cada área troca pela marca do contexto.
installTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (count, error) => !(error instanceof ApiError && error.status >= 400 && error.status < 500) && count < 2,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Movimento: biblioteca carregada sob demanda (LazyMotion) e redução automática conforme o sistema. */}
    <LazyMotion features={domAnimation} strict>
      <MotionConfig reducedMotion="user" transition={{ duration: 0.22, ease: [0.2, 0.8, 0.2, 1] }}>
        <QueryClientProvider client={queryClient}>
          <SessionProvider>
            <ToastProvider>
              <RouterProvider router={router} />
            </ToastProvider>
          </SessionProvider>
        </QueryClientProvider>
      </MotionConfig>
    </LazyMotion>
  </StrictMode>,
);
